import React, { useEffect, useRef } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import QuotationOrderEdit from './QuotationOrderEdit';
import { Button, Image } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import moment from 'moment';
import DownloadExcel from '../../report/DownloadExcel';

export default function AliVoice(props: any) {

    const ref = useRef<any>(undefined);

    /** api服务id */
    const apiId = 'quotationNotice';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据




    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'quotationNoticeName',
        },
        {
            title: '模式',
            dataIndex: 'quotationNoticeStatusName',
        },
        {
            title: '有效期',
            dataIndex: 'voiceId',
            render: (text: any, record: any) => {

                return <>{record.isForEver ? "永久" : `${moment(record.startTime).format("YYYY-MM-DD HH:mm:ss")}~${moment(record.endTime).format("YYYY-MM-DD HH:mm:ss")}`}</>
            }
        },
        {
            title: '创建人',
            dataIndex: 'createUserName',

        },
    ];
    const reviewQuotationOrder = (id: string, quotationStatus: number) => {
        fetchApi.POST(wmService, {
            apiId: "quotationOrder",
            apiExtend: "reviewQuotationOrder",
            apiData: {
                quotationOrderId: id,
                quotationStatus
            }
        }).then((res) => {
            if (res.success) {
                const currentData: initDataType = {
                    apiId,
                }
                ref.current.initData(currentData);
            }
        }).catch((err) => {
            console.log(err);

        })
    }
    const columns = columnsheadId
        .concat(columnsHead as []);

    // 子表格列配置函数
    const getExpandableColumns = (mainRecord: any) => {
        return [
            {
                title: "产品",
                dataIndex: "product",
                render: (text: any, record: any) => {
                    return <>{text.productName}</>
                }
            },
            {
                title: "单位",
                dataIndex: "product",
                render: (text: any, record: any) => {
                    return <>{text.productUnit.productUnitName}</>
                }
            },
            {
                title: "规格",
                dataIndex: "productSpecifications",

            },

            {
                title: "备注",
                dataIndex: "memo"
            },

        ];
    }
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '报价公告',
        apiId,
        columns,
        expandableColumns: getExpandableColumns,
        // showImage: true,
        // showUploadFile: true,
        expandableDataName: "quotationNoticeProducts",
        showStates: true,
        showEdit: false,
        pagination: true,
        bulkInsert: true,
        isExpandable: true,
        // InsertComponent: QuotationOrderEdit,
        // EditComponent: QuotationOrderEdit,
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
        </>
    )
}